/**
 * Тексты секретных звонков (docs/encryption/E2E-CALLS.md, §9). На экране —
 * только то, что известно, и что делать.
 */
export const SECRET_CALL_TEXTS = {
  title: 'Секретный звонок',
  peerUnsupported:
    'Собеседник пока не может принимать секретные звонки: его приложение не поддерживает их. Позвонить можно из обычного чата.',
  browser:
    'Этот браузер не поддерживает секретные звонки. Откройте ROOMS в Chrome, Edge, Safari или Firefox последней версии.',
  keyChanged:
    'Ключ собеседника изменился. Так бывает после входа на новом устройстве. Сверьте код безопасности при разговоре.',
  otherDevice: 'Секретный звонок можно принять только на устройстве, где включены секретные чаты.',
  keyFailed: 'Не удалось получить ключ звонка. Попросите собеседника перезвонить.',
  appOutdated: 'Секретные звонки недоступны в этой версии приложения. Обновите приложение.',
  unencryptedPeer: 'Собеседник подключился без шифрования. Звонок завершён.',
  establishing: 'Устанавливаем защищённое соединение…',
  verifyHint: 'Совпадает с кодом безопасности секретного чата',
} as const
